import { render, staticRenderFns } from "./RightsGroup.vue?vue&type=template&id=0cee87ca"
import script from "./RightsGroup.vue?vue&type=script&lang=js"
export * from "./RightsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports